const DashboardValue = ({ label, value, position }) => {

  return<div className="dashboard-value" style={{ ...position }}>
    <div className="dashboard-value-value">{value}</div>
    <div className="dashboard-value-label">{label}</div>
  </div>
}

export default DashboardValue;